import type { ReactNode } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { useSession } from "./hooks/useSession";
import { MARKETING_URL } from "./env";
import AppShell from "./layout/AppShell";
import Reports from "./screens/Reports";
import Settings from "./screens/Settings";
import ComingSoon from "./screens/ComingSoon";
import Onboarding from "./screens/Onboarding";

function RequireAuth({ children }: { children: ReactNode }) {
  const { user, loading } = useSession();
  if (loading) return null;
  if (!user) {
    const back = encodeURIComponent(window.location.href);
    window.location.replace(`${MARKETING_URL}/signin?redirect=${back}`);
    return null;
  }
  return <>{children}</>;
}

export default function App() {
  return (
    <Routes>
      <Route
        element={
          <RequireAuth>
            <AppShell />
          </RequireAuth>
        }
      >
        <Route index element={<Navigate to="/reports" replace />} />
        <Route path="/overview" element={<ComingSoon screen="Overview" />} />
        <Route path="/onboarding" element={<Onboarding />} />
        <Route path="/reports" element={<Reports />} />
        <Route path="/reports/:reportId" element={<Reports />} />
        <Route path="/alerts" element={<ComingSoon screen="Alerts" />} />
        <Route path="/settings" element={<Settings />} />
      </Route>

      <Route path="*" element={<Navigate to="/reports" replace />} />
    </Routes>
  );
}
